import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { Observable } from "rxjs";
import { PesquisaBasicaJornalInputDto } from "../domain/DTOs/input/pesquisa-basica-jornal.input.dto";
import { EstruturaRetornoDadosPaginadosOutputDto } from "../domain/DTOs/output/estrutura-retorno-dados-paginados.output.dto";
import { ResultadoPesquisaJornalOutputDto } from "../domain/DTOs/output/jornal/resultado-pesquisa-jornal.output.dto";

@Injectable()
export class PesquisaService{
  
  constructor(private readonly baseService: BaseService) {}

  public PesquisarJornaisPaginados(
    inputDto: PesquisaBasicaJornalInputDto
  ): Observable <EstruturaRetornoDadosPaginadosOutputDto<ResultadoPesquisaJornalOutputDto[]>> {
    const termoCodificado = encodeURIComponent(inputDto.textoPesquisa); 
    const filtroPaginado = {
      ...inputDto,
      TamanhoPagina: inputDto.TamanhoPagina && inputDto.TamanhoPagina > 0 ? inputDto.TamanhoPagina : 20
    };

    return this.baseService.getFiltered(
      `Pesquisa/PesquisarJornaisPaginados`,
      `DataPublicacaoInicial=${inputDto.dataPublicacaoInicial}&DataPublicacaoFinal=${inputDto.dataPublicacaoFinal}&TextoPesquisa=${termoCodificado}&DiarioExecutivo=${inputDto.diarioExecutivo}&DiarioMunicipios=${inputDto.diarioMunicipios}&DiarioTerceiros=${inputDto.diarioTerceiros}&EdicaoExtra=${inputDto.edicaoExtra}&DiarioJudiciario=${inputDto.diarioJudiciario ?? false}&DiarioLegislativo=${inputDto.diarioLegislativo ?? false}`,
      filtroPaginado
    )
  }
}